import React, { Component } from 'react';
import { CodetableListItemsProps } from './types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableItemRow } from './common/codetable-item-row';
import { CodetableListItemsContainer } from './codetable-list-items-container';
import { CodetableItem } from './codetable-item';
import { CodetableHeading } from 'app/area/codetable/list/list-items/codetable-heading';
import { CodeDrop } from 'app/area/codetable/list/list-items/drag-and-drop/code-drop';
import { CodeDragItemType, mdResolution } from 'app/area/codetable/list/constants';
import { DragAndDropItem } from 'app/area/codetable/list/list-items/drag-and-drop/drag-and-drop-item';
import styles from './codetable-list-items.scss';

export class CodetableListItems extends Component<CodetableListItemsProps> {

  public render() {

    const { itemAccess, fetchingItemAccess, codetableId, codetableName, parentId, codeListBranch, validation,
      codeListBranchState, codeId, isZebra, isHierarchyMode, isHierarchy, breadcrumbs, codeAccessConfiguration,
      deletingCodeItem, translation, treeDepthLevel, hierarchyMetadata, metadata, options, fetchingCodeParent,
      loadFromParent, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess,
      resetValidation, loadOptions, addLinkFactory, updateMergeCode, updateCodeParent, updateConfirmPrompt
    } = this.props;

    const currentBranch = codeListBranch.find(item => item.id === parentId);
    const currentCodeItem = currentBranch?.items || [];
    const currentBranchState = codeListBranchState?.find(state => state.id === parentId);
    const fetching = !!currentBranchState?.fetching;
    const needsReload = !!currentBranchState?.needsReload;
    const deletingCodeItems = codeListBranch?.[0]?.items?.some(item => !!item.deletingCodeItem);

    return <>
      <CodetableListItemsContainer
        parentId={parentId}
        codeBranch={currentBranch}
        codeBranchState={currentBranchState}
        loadFromParent={loadFromParent}>
        {
          metadata?.features?.sequence && treeDepthLevel === 0
            ? <CodetableHeading codetableName={codetableName} sequenceName={translation.sequence} isHierarchy={isHierarchyMode} />
            : null
        }
        {currentCodeItem.map((codeItem, index) => {

          const codeItemState = codeListBranchState?.find(state => state.id === codeItem.id);
          const open = !!codeItemState?.open;
          const showSpinner = codeItemState?.isUpdatingParent && codeItemState.id === codeItem.id;
          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;
          const isLastChild = currentCodeItem?.length === index + 1;
          const hasChildren = isHierarchyMode && !!codeItem.childrenCount;
          const hierarchyMetadataUpdated: HierarchyMetadata[] = [...hierarchyMetadata, {
            depthLevel: treeDepthLevel,
            hasChildren,
            isLastChild
          }];

          const rootDropCodeContainer = codeAccessConfiguration.canCreate && isHierarchyMode
            && <CodeDrop
              codeListBranch={codeListBranch}
              isRoot={true}
              dropCodeId={codeItem.id}
              type={CodeDragItemType.codeTile}
              updateCodeParent={updateCodeParent} />;

          const defaultCodetableItem = <CodetableItem
            itemAccess={itemAccess}
            fetchingItemAccess={fetchingItemAccess}
            breadcrumbs={breadcrumbs}
            isZebra={isZebraValue}
            hierarchyMetadata={hierarchyMetadataUpdated}
            treeDepthLevel={treeDepthLevel}
            codetableId={codetableId}
            codeId={codeId}
            refetching={fetching && needsReload || showSpinner || fetchingCodeParent}
            isHierarchyMode={isHierarchyMode}
            isHierarchy={isHierarchy}
            open={open}
            parentId={parentId}
            codeItem={codeItem}
            expandCodeItem={expandCodeItem}
            deleteCodeItem={deleteCodeItem}
            loadCodesAccess={loadCodesAccess}
            clearCodesAccess={clearCodesAccess}
            deletingCodeItem={deletingCodeItem || codeItem.deletingCodeItem}
            deletingCodeItems={deletingCodeItems}
            translation={translation}
            isLastChild={!open && isLastChild}
            codeAccessConfiguration={codeAccessConfiguration}
            addLinkFactory={addLinkFactory}
            metadata={metadata}
            options={options}
            validation={validation}
            loadOptions={loadOptions}
            updateMergeCode={updateMergeCode}
            updateConfirmPrompt={updateConfirmPrompt}
            resetValidation={resetValidation} />;

          const isMobile = (this.props as CodetableListItemsProps & { width: number }).width <= mdResolution;

          const codetableItemComponent =
            !isMobile && codeAccessConfiguration.canCreate
              && isHierarchyMode && codeItem.id !== 0
              ? <DragAndDropItem
                codeListBranch={codeListBranch}
                codeItem={codeItem}
                updateCodeParent={updateCodeParent}>
                {defaultCodetableItem}
              </DragAndDropItem>
              : defaultCodetableItem;

          const displayRootCodeContainer = index === 0 && !parentId && rootDropCodeContainer;

          return <div key={codeItem.id} className={codeItem.deletingCodeItem ? styles.deleting : ''}>
            {displayRootCodeContainer}
            {codetableItemComponent}
            {open && <div>
              <CodetableListItems
                {...this.props}
                hierarchyMetadata={hierarchyMetadataUpdated}
                deletingCodeItem={codeItem.deletingCodeItem || deletingCodeItem}
                parentId={codeItem.id}
                treeDepthLevel={treeDepthLevel + 1}
                isZebra={isZebraValue}
              />
            </div>}
          </div>;
        })}
      </CodetableListItemsContainer>
      {fetching && !needsReload && <CodetableItemRow isZebra={isZebra} isLoader>
        <CodetableItemLoader>
          {translation.loading}
        </CodetableItemLoader>
      </CodetableItemRow>}
    </>;
  }
}
